// date format for Datepicker and RagerPicker Component
export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const SEARCH_CIDADES_WATCH = 1000;
export const SEARCH_PRODUTOS_WATCH = 1000;
export const SEARCH_CLIENTES_WATCH = 1000;
export const RANGER_DEFAULT_DATE = { days: 7, unity: 'days' };
export const RANGER_DATE_LIMIT = { limit: 7, unitOfTime: 'months' };
export const SORTER_DEFAULT_PARAMS = {
  ordenar_pela_coluna: 'data_emissao',
  metodo_ordenacao: 'DESC',
};
